import React from 'react';
import { styled, Tooltip, TooltipProps, Typography, useTheme, tooltipClasses } from '@mui/material';
import Ellipsis from '../../Ellipsis';
import Row from '../../Row';
import CircledNumber from './circledNumber';
import { InfoOutlined } from '@mui/icons-material';

interface TitleProps {
  value: string;
  ellipsis?: boolean;
  numberValue?: string;
  addMargin?: number;
  status?: 'warning' | 'error' | 'success';
  infoText?: string;
}

const Title: React.FC<TitleProps> = ({ value, ellipsis, numberValue, addMargin, status, infoText }) => {
  const theme = useTheme();
  const titleAndInfoColor = theme.palette.grey[600];
  const CustomTitleStyle = {
    color: titleAndInfoColor,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '14px',
    letterSpacing: 0.15,
  };

  const titleContent = (
    <Typography style={{ ...CustomTitleStyle, textTransform: 'uppercase' }} variant="h3">
      {value}
    </Typography>
  );

  return (
    <>
      {ellipsis ? (
        <TitleRow>
          <Ellipsis style={{ ...CustomTitleStyle, textTransform: 'uppercase' }} variant="h3">
            {value}
          </Ellipsis>
          <>{numberValue && <CircledNumber value={numberValue} status={status} />}</>
        </TitleRow>
      ) : (
        <TitleRow style={{ height: 20, marginBottom: addMargin, display: 'flex', alignItems: 'center' }}>
          {infoText ? (
            <>
              {titleContent}
              <CustomTooltip title={infoText} placement="top-end" arrow>
                <InfoOutlined sx={{ width: 18, ml: 0.5, color: titleAndInfoColor }} />
              </CustomTooltip>
            </>
          ) : (
            titleContent
          )}
          <>{numberValue && <CircledNumber value={numberValue} status={status} />}</>
        </TitleRow>
      )}
    </>
  );
};

export default Title;

export const TitleRow = styled(Row)(() => ({
  height: 20,
  marginBottom: 8,
  display: 'flex',
  alignItems: 'center',
}));

// Tooltip personalizzato con fontSize più grande
const CustomTooltip = styled(({ className, ...props }: { className?: string } & TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontSize: 14,
      padding: theme.spacing(1),
    },
  })
);
